import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutSection: React.FC = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <section id="about" className="py-8 sm:py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        {/* Title */}
        <h2 className="font-serif text-2xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-deep-teal mb-6 sm:mb-8 md:mb-10 lg:mb-12">
          Meet Your Kauai Bridal Stylist
        </h2>



        {/* Image */}
        <div className="mb-6 sm:mb-8 md:mb-10 lg:mb-12">
          <img
            src="/photos/self1.jpg"
            alt="Your Kauai bridal stylist"
            className="w-full max-w-64 sm:max-w-80 md:max-w-96 lg:max-w-112 mx-auto h-64 sm:h-80 md:h-96 lg:h-112 object-cover rounded-full shadow-xl"
          />
        </div>

        <h2 className="font-serif text-2xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-deep-teal mb-6 sm:mb-8 md:mb-10 lg:mb-12 text-center">
          Ericka Dela Cruz
        </h2>

        {/* Bio Content */}
        <div className="space-y-3 sm:space-y-4 md:space-y-6 text-gray-700 leading-relaxed text-left max-w-3xl mx-auto">
          <h3 className="font-serif text-lg sm:text-xl md:text-2xl text-deep-teal text-center mb-3 sm:mb-4 md:mb-6">
            For Brides Who Care About Every Detail
          </h3>

          <p className="text-sm sm:text-base">
            Aloha! I'm born and raised on the beautiful island of Kauai, and I've always had a passion for beauty and makeup since middle school. After graduating from Paul Mitchell, I spent over 15 years perfecting my craft in the art of beauty! I've had the incredible privilege of being part of hundreds of love stories, each one unique and beautiful in its own way.
          </p>

          <p className="text-sm sm:text-base">
            As a wife and mother of four amazing kids (and two adorable dogs who think they run the house!), I understand the importance of feeling confident and beautiful while staying true to who you are. Living on Kauai my entire life has given me an intimate understanding of our island's unique beauty challenges and opportunities.
          </p>

          <p className="text-sm sm:text-base">
            <strong>Your wedding day is sacred.</strong> I know how much this day means to you—it's not just another event, it's the beginning of your forever. Every bride deserves to feel absolutely radiant as she walks down the aisle, and I understand the weight of that responsibility. My own wedding day taught me that the most stunning brides are those who feel completely comfortable in their own skin, knowing that every detail has been thoughtfully planned and perfectly executed.
          </p>

          <p className="text-sm sm:text-base">
            My services are not for brides who simply want someone to apply makeup and style hair. I work exclusively with brides who care deeply about their wedding day experience—women who understand that true beauty comes from feeling confident, prepared, and authentically themselves. If you're the type of bride who values expert preparation, attention to detail, and wants a stylist who truly understands the significance of your special day, then we're meant to work together.
          </p>
        </div>

        <div className="mt-4 sm:mt-6 md:mt-8 p-3 sm:p-4 md:p-6 bg-soft-cream rounded-lg">
          <h3 className="font-serif text-base sm:text-lg md:text-xl lg:text-2xl text-deep-teal mb-2 sm:mb-3 md:mb-4">My Philosophy</h3>
          <p className="text-sm sm:text-base text-gray-700 italic leading-relaxed">
            "True beauty isn't about transformation—it's about revealing the radiance
            that's already within you. My goal is to create effortless glam that enhances
            your natural beauty, boosts your confidence, and lasts from your first look
            to your last dance under the Kauai stars."
          </p>
        </div>

        <div className="mt-4 sm:mt-6 md:mt-8 grid grid-cols-2 gap-3 sm:gap-4 md:gap-6">
          <div className="text-center">
            <div className="text-xl sm:text-2xl md:text-3xl font-bold text-sunset-coral mb-1 sm:mb-2">15+</div>
            <div className="text-xs sm:text-sm text-gray-600">Years of Experience</div>
          </div>
          <div className="text-center">
            <div className="text-xl sm:text-2xl md:text-3xl font-bold text-island-sage mb-1 sm:mb-2">100+</div>
            <div className="text-xs sm:text-sm text-gray-600">Beautiful Brides</div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="mt-8 sm:mt-12 md:mt-16 lg:mt-20 text-center bg-deep-teal text-white p-4 sm:p-6 md:p-8 lg:p-12 rounded-lg">
          <h3 className="font-serif text-lg sm:text-xl md:text-2xl lg:text-3xl mb-3 sm:mb-4 md:mb-6">
            Ready to Start Your Bridal Beauty Journey?
          </h3>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-4 sm:mb-6 md:mb-8 leading-relaxed max-w-2xl mx-auto">
            I'd love to learn about your vision and help you feel absolutely stunning
            on your Kauai wedding day. Let's create something beautiful together.
          </p>
          <button
            onClick={handleContactClick}
            className="inline-block bg-sunset-coral hover:bg-opacity-90 text-white font-semibold py-2 px-4 sm:py-3 sm:px-6 md:py-4 md:px-8 lg:px-12 rounded-full text-xs sm:text-sm md:text-base lg:text-xl transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            Contact Us
          </button>
          <p className="mt-2 sm:mt-3 md:mt-4 text-gray-300 text-xs sm:text-sm md:text-base">
            Complimentary consultation • No pressure • Just beautiful possibilities
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
